import React from 'react';
import {
  MessageCircle,
  Mail,
  Phone,
  Clock,
  ShieldAlert,
  BookOpen,
  ExternalLink,
  LifeBuoy,
} from 'lucide-react';

const descricoes = {
  ASAAS: 'Suporte para integração, API, webhooks, Sandbox e canais oficiais de atendimento.',
  CPFL: 'Suporte CPFL Total, refaturamento e contatos operacionais.',
  'PIX TOOLS': 'Suporte para Pix Recorrente Santander e contatos de atendimento.'
};

const cardStyle = {
  padding: 22,
  border: '1px solid #e2e8f0',
  borderRadius: 12,
  background: '#fff',
  boxShadow: '0 2px 8px rgba(15, 23, 42, .04)',
};

const actionStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 9,
  padding: '11px 15px',
  border: '1px solid #bfdbfe',
  borderRadius: 9,
  background: '#eff6ff',
  color: '#1d4ed8',
  fontSize: 14,
  fontWeight: 600,
  textDecoration: 'none',
};

function SuporteAsaas() {
  const corpoEmail = [
    'Olá, time de Integrações Asaas!',
    '',
    'Precisamos de apoio com a integração abaixo:',
    '',
    'Ambiente (Sandbox ou Produção):',
    'Recurso ou endpoint:',
    'Método HTTP:',
    'Data e horário aproximado, com fuso:',
    'Código HTTP:',
    'Mensagem de erro:',
    'ID do recurso:',
    'Resultado esperado:',
    'Resultado observado:',
    '',
    'Payload enviado (sem dados sensíveis):',
    'Resposta recebida (sem dados sensíveis):',
    '',
    'Removemos ou mascaramos chaves, tokens, senhas e outros dados sensíveis.',
  ].join('\n');

  const linkEmail =
    `mailto:integracoes@asaas.com.br?subject=${encodeURIComponent('Suporte técnico - integração Asaas')}` +
    `&body=${encodeURIComponent(corpoEmail)}`;

  const linkWhatsapp =
    'https://wa.me/558000090037';

  return (
    <div style={{ display: 'grid', gap: 16 }}>
      <section style={cardStyle}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
          <div style={{
            display: 'grid',
            placeItems: 'center',
            flex: '0 0 42px',
            width: 42,
            height: 42,
            borderRadius: 11,
            color: '#2563eb',
            background: '#eff6ff',
          }}>
            <LifeBuoy size={21} />
          </div>
          <div>
            <h2 style={{ margin: '0 0 7px', color: '#1e293b', fontSize: 18 }}>
              Suporte técnico de integração
            </h2>
            <p style={{ margin: 0, color: '#64748b', fontSize: 14, lineHeight: 1.6 }}>
              Para dúvidas ou problemas com API, webhooks, autenticação, Sandbox
              ou respostas inesperadas da integração.
            </p>
          </div>
        </div>

        <div style={{ marginTop: 18 }}>
          <a href={linkEmail} style={actionStyle}>
            <Mail size={17} />
            Preparar e-mail para o Asaas
          </a>
        </div>

        <p style={{ margin: '13px 0 0', color: '#64748b', fontSize: 13, lineHeight: 1.5 }}>
          Atendimento em dias úteis, das 8h às 19h. O Asaas informa tempo típico
          de resposta de até 2 horas durante o horário de atendimento.
        </p>
      </section>

      <section style={{ ...cardStyle, display: 'grid', gap: 18 }}>
        <div>
          <h2 style={{ margin: '0 0 7px', color: '#1e293b', fontSize: 18 }}>
            Outros canais de atendimento
          </h2>
          <p style={{ margin: 0, color: '#64748b', fontSize: 14, lineHeight: 1.5 }}>
            Para assuntos comerciais ou relacionados à conta, utilize os canais
            de atendimento do Asaas.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: 14,
        }}>
          <div style={{
            padding: 17,
            border: '1px solid #e2e8f0',
            borderRadius: 10,
            background: '#f8fafc',
          }}>
            <h3 style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              margin: '0 0 8px',
              color: '#1e293b',
              fontSize: 15,
            }}>
              <MessageCircle size={18} color="#16a34a" />
              WhatsApp
            </h3>
            <p style={{ margin: '0 0 13px', color: '#64748b', fontSize: 13, lineHeight: 1.5 }}>
              0800 009 0037 — canal de mensagens para assuntos comerciais e da conta.
            </p>
            <a href={linkWhatsapp} target="_blank" rel="noopener noreferrer" style={actionStyle}>
              Abrir WhatsApp
              <ExternalLink size={15} />
            </a>
          </div>

          <div style={{
            padding: 17,
            border: '1px solid #e2e8f0',
            borderRadius: 10,
            background: '#f8fafc',
          }}>
            <h3 style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              margin: '0 0 8px',
              color: '#1e293b',
              fontSize: 15,
            }}>
              <Phone size={18} color="#2563eb" />
              Telefone e chat
            </h3>
            <p style={{ margin: '0 0 13px', color: '#64748b', fontSize: 13, lineHeight: 1.5 }}>
              Telefone: 0800 009 0037. O chat fica disponível ao acessar sua conta Asaas.
            </p>
            <a
              href="https://www.asaas.com/"
              target="_blank"
              rel="noopener noreferrer"
              style={actionStyle}
            >
              Acessar conta Asaas
              <ExternalLink size={15} />
            </a>
          </div>
        </div>
      </section>

      <section style={{
        ...cardStyle,
        borderColor: '#fde68a',
        background: '#fffbeb',
        boxShadow: 'none',
      }}>
        <h2 style={{
          display: 'flex',
          alignItems: 'center',
          gap: 9,
          margin: '0 0 8px',
          color: '#92400e',
          fontSize: 16,
        }}>
          <ShieldAlert size={19} />
          Proteja suas credenciais
        </h2>
        <p style={{ margin: 0, color: '#78350f', fontSize: 14, lineHeight: 1.6 }}>
          Nunca envie chave de API, token, senha ou dados completos de cartão por
          e-mail ou WhatsApp. Remova ou mascare informações sensíveis antes de
          compartilhar logs, payloads ou capturas de tela.
        </p>
      </section>

      <section style={{ ...cardStyle, padding: 17 }}>
        <a
          href="https://docs.asaas.com/docs/entre-em-contato"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 9,
            color: '#2563eb',
            fontSize: 14,
            fontWeight: 600,
            textDecoration: 'none',
          }}
        >
          <BookOpen size={17} />
          Consultar orientações oficiais de contato do Asaas
          <ExternalLink size={14} />
        </a>

        <p style={{
          display: 'flex',
          alignItems: 'center',
          gap: 7,
          margin: '12px 0 0',
          color: '#64748b',
          fontSize: 12,
        }}>
          <Clock size={14} />
          O e-mail abre no aplicativo de correio configurado neste computador.
        </p>
      </section>
    </div>
  );
}


function SuportePixTools() {
  const corpoEmail = [
    'Olá, equipe de suporte Pix Recorrente,',
    '',
    'Preciso de ajuda com a operação abaixo:',
    '',
    'Card: 17293925',
    'Empresa: SOUL POLICLINICA LTDA',
    'CNPJ: 38.244.541/0001-38',
    '',
    'Descrição da solicitação:',
    '',
    'Data e horário aproximado:',
    'Identificador da transação, se aplicável:',
    '',
    'Obrigado.',
  ].join('\n');

  const assuntoEmail = 'Ajuda Pix Recorrente - SOUL POLICLINICA LTDA - Card 17293925';
  const emailSuporte =
    `mailto:suporte.conectividade@santander.com.br?subject=${encodeURIComponent(assuntoEmail)}` +
    `&body=${encodeURIComponent(corpoEmail)}`;

  const corpoGerente = [
    'Olá, Gislaine,',
    '',
    'Preciso de ajuda com o Pix Recorrente.',
    '',
    'Card: 17293925',
    'Empresa: SOUL POLICLINICA LTDA',
    'CNPJ: 38.244.541/0001-38',
    '',
    'Descrição:',
  ].join('\n');

  const emailGerente =
    `mailto:gislaine.carvalho@toolsds.com?subject=${encodeURIComponent(assuntoEmail)}` +
    `&body=${encodeURIComponent(corpoGerente)}`;

  const mensagemWhatsApp = encodeURIComponent(
    'Olá, Luciana. Preciso de ajuda com o Pix Recorrente da SOUL POLICLINICA LTDA. Card 17293925.'
  );
  const whatsappLuciana = `https://wa.me/5519998717380?text=${mensagemWhatsApp}`;

  const contatoCardStyle = {
    padding: 18,
    border: '1px solid #e2e8f0',
    borderRadius: 10,
    background: '#f8fafc',
  };

  return (
    <div style={{ display: 'grid', gap: 16 }}>
      <section style={cardStyle}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
          <div style={{
            display: 'grid',
            placeItems: 'center',
            flex: '0 0 42px',
            width: 42,
            height: 42,
            borderRadius: 11,
            color: '#2563eb',
            background: '#eff6ff',
          }}>
            <LifeBuoy size={21} />
          </div>
          <div>
            <h2 style={{ margin: '0 0 7px', color: '#1e293b', fontSize: 18 }}>
              Ajuda com Pix Recorrente
            </h2>
            <p style={{ margin: 0, color: '#64748b', fontSize: 14, lineHeight: 1.6 }}>
              Fale com a equipe de conectividade Santander. O e-mail será aberto
              com os dados de identificação da empresa já preenchidos.
            </p>
          </div>
        </div>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 16 }}>
          <span style={{ padding: '6px 10px', borderRadius: 20, background: '#f1f5f9', color: '#334155', fontSize: 13 }}>
            Card: 17293925
          </span>
          <span style={{ padding: '6px 10px', borderRadius: 20, background: '#f1f5f9', color: '#334155', fontSize: 13 }}>
            SOUL POLICLINICA LTDA
          </span>
          <span style={{ padding: '6px 10px', borderRadius: 20, background: '#f1f5f9', color: '#334155', fontSize: 13 }}>
            CNPJ: 38.244.541/0001-38
          </span>
        </div>

        <div style={{ marginTop: 18 }}>
          <a href={emailSuporte} style={actionStyle}>
            <Mail size={17} />
            Enviar e-mail ao suporte Pix Recorrente
          </a>
        </div>
        <p style={{ margin: '12px 0 0', color: '#64748b', fontSize: 12, lineHeight: 1.5 }}>
          Destinatário: suporte.conectividade@santander.com.br. Revise e complete
          a descrição antes de enviar.
        </p>
      </section>

      <section style={{ ...cardStyle, display: 'grid', gap: 16 }}>
        <div>
          <h2 style={{ margin: '0 0 7px', color: '#1e293b', fontSize: 18 }}>
            Contatos Santander
          </h2>
          <p style={{ margin: 0, color: '#64748b', fontSize: 14, lineHeight: 1.5 }}>
            Escolha o canal adequado para sua região ou fale com a gerente responsável.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: 14,
        }}>
          <div style={contatoCardStyle}>
            <h3 style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              margin: '0 0 10px',
              color: '#1e293b',
              fontSize: 15,
            }}>
              <Phone size={18} color="#2563eb" />
              Atendimento por telefone
            </h3>
            <p style={{ margin: '0 0 8px', color: '#64748b', fontSize: 13 }}>
              Capitais e regiões metropolitanas
            </p>
            <a href="tel:40042125" style={{ color: '#1d4ed8', fontWeight: 600, textDecoration: 'none' }}>
              4004-2125
            </a>
            <p style={{ margin: '12px 0 8px', color: '#64748b', fontSize: 13 }}>
              Interior e outras localidades
            </p>
            <a href="tel:08007262125" style={{ color: '#1d4ed8', fontWeight: 600, textDecoration: 'none' }}>
              0800 726 2125
            </a>
          </div>

          <div style={contatoCardStyle}>
            <h3 style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              margin: '0 0 10px',
              color: '#1e293b',
              fontSize: 15,
            }}>
              <MessageCircle size={18} color="#2563eb" />
              Nossa gerente
            </h3>
            <p style={{ margin: '0 0 5px', color: '#1e293b', fontSize: 14, fontWeight: 600 }}>
              Gislaine Carvalho
            </p>
            <p style={{ margin: '0 0 12px', color: '#64748b', fontSize: 13, lineHeight: 1.5 }}>
              Client Services / Onboarding Cash Atacado
            </p>
            <p style={{ margin: '0 0 8px', color: '#64748b', fontSize: 13 }}>
              <a href="tel:+551130122711" style={{ color: '#1d4ed8', textDecoration: 'none' }}>
                (11) 3012-2711
              </a>
            </p>
            <a href={emailGerente} style={actionStyle}>
              <Mail size={16} />
              Escrever para Gislaine
            </a>
          </div>

          <div style={contatoCardStyle}>
            <h3 style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              margin: '0 0 10px',
              color: '#1e293b',
              fontSize: 15,
            }}>
              <MessageCircle size={18} color="#16a34a" />
              WhatsApp
            </h3>
            <p style={{ margin: '0 0 13px', color: '#64748b', fontSize: 13, lineHeight: 1.5 }}>
              Luciana Santander
            </p>
            <a
              href={whatsappLuciana}
              target="_blank"
              rel="noopener noreferrer"
              style={actionStyle}
            >
              Abrir conversa no WhatsApp
              <ExternalLink size={15} />
            </a>
          </div>
        </div>
      </section>

      <section style={{ ...cardStyle, display: 'grid', gap: 12 }}>
        <h2 style={{ margin: 0, color: '#1e293b', fontSize: 18 }}>
          Endereços TOOLS
        </h2>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: 14,
        }}>
          <div style={contatoCardStyle}>
            <h3 style={{ margin: '0 0 7px', color: '#1e293b', fontSize: 15 }}>
              TOOLS
            </h3>
            <p style={{ margin: 0, color: '#64748b', fontSize: 14, lineHeight: 1.6 }}>
              Av. Limeira, 222 — Vila Rezende, Piracicaba — 5º andar.
            </p>
          </div>
          <div style={contatoCardStyle}>
            <h3 style={{ margin: '0 0 7px', color: '#1e293b', fontSize: 15 }}>
              Estação Tools Piracicaba
            </h3>
            <p style={{ margin: 0, color: '#64748b', fontSize: 14, lineHeight: 1.6 }}>
              Av. Limeira, 222 — Piracicaba/SP — 3º andar.
            </p>
          </div>
        </div>
      </section>

      <section style={{
        ...cardStyle,
        padding: 16,
        borderColor: '#fde68a',
        background: '#fffbeb',
        boxShadow: 'none',
      }}>
        <p style={{ margin: 0, color: '#78350f', fontSize: 13, lineHeight: 1.6 }}>
          O botão de e-mail abre o aplicativo de correio configurado neste computador.
          Confira os dados e acrescente a descrição do problema antes de enviar.
        </p>
      </section>
    </div>
  );
}


function SuporteCpfl() {
  const destinatariosRefaturamento = [
    'Refaturamento@cpfl.com.br',
    'Gmp@cpfl.com.br',
    'Cpfltotalnovosnegocios@cpfl.com.br',
  ].join(',');

  const assuntoRefaturamento =
    'Solicitação de Refaturamento - cliente [NOME DO CLIENTE] - UC: [NÚMERO DA UC]';

  const corpoRefaturamento = [
    'Prezados,',
    '',
    'Solicito refaturamento para o cliente [NOME DO CLIENTE], UC: [NÚMERO DA UC],',
    'que teve na fatura do mês [MÊS/ANO] a cobrança do nosso serviço',
    '"Cartão da Família" duplicada.',
    '',
    'Solicito o refaturamento e o envio da nova cobrança para ser disponibilizada ao cliente.',
    '',
    'Atenciosamente,',
    '[NOME]',
    '[TELEFONE]',
  ].join('\n');

  const emailRefaturamento =
    `mailto:${destinatariosRefaturamento}` +
    `?subject=${encodeURIComponent(assuntoRefaturamento)}` +
    `&body=${encodeURIComponent(corpoRefaturamento)}`;

  const emailNayara =
    `mailto:nayara@cpfl.com.br?subject=${encodeURIComponent('Contato - CPFL Total')}`;

  const emailRonaldo =
    `mailto:ronaldo.zanes@cpfl.com.br?subject=${encodeURIComponent('Contato - CPFL Total')}`;

  const textoWhatsApp = encodeURIComponent(
    'Olá, Ronaldo. Preciso de ajuda com uma solicitação relacionada à CPFL.'
  );
  const whatsappRonaldo = `https://wa.me/5519993284705?text=${textoWhatsApp}`;

  const contatoCardStyle = {
    padding: 18,
    border: '1px solid #e2e8f0',
    borderRadius: 10,
    background: '#f8fafc',
  };

  return (
    <div style={{ display: 'grid', gap: 16 }}>
      <section style={cardStyle}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
          <div style={{
            display: 'grid',
            placeItems: 'center',
            flex: '0 0 42px',
            width: 42,
            height: 42,
            borderRadius: 11,
            color: '#2563eb',
            background: '#eff6ff',
          }}>
            <LifeBuoy size={21} />
          </div>
          <div>
            <h2 style={{ margin: '0 0 7px', color: '#1e293b', fontSize: 18 }}>
              Solicitação de refaturamento
            </h2>
            <p style={{ margin: 0, color: '#64748b', fontSize: 14, lineHeight: 1.6 }}>
              Use este modelo quando a cobrança do serviço Cartão da Família
              aparecer duplicada na fatura do cliente.
            </p>
          </div>
        </div>

        <div style={{ marginTop: 18 }}>
          <a href={emailRefaturamento} style={actionStyle}>
            <Mail size={17} />
            Preparar e-mail de refaturamento
          </a>
        </div>

        <p style={{ margin: '12px 0 0', color: '#64748b', fontSize: 13, lineHeight: 1.5 }}>
          Destinatários: Refaturamento@cpfl.com.br, Gmp@cpfl.com.br e
          Cpfltotalnovosnegocios@cpfl.com.br. Complete os campos entre colchetes
          antes de enviar.
        </p>
      </section>

      <section style={{ ...cardStyle, display: 'grid', gap: 16 }}>
        <div>
          <h2 style={{ margin: '0 0 7px', color: '#1e293b', fontSize: 18 }}>
            Contatos CPFL
          </h2>
          <p style={{ margin: 0, color: '#64748b', fontSize: 14, lineHeight: 1.5 }}>
            CPFL Energia / Alesta. Funcionamento informado: segunda a sexta-feira,
            das 8h às 17h.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: 14,
        }}>
          <div style={contatoCardStyle}>
            <h3 style={{ margin: '0 0 10px', color: '#1e293b', fontSize: 15 }}>
              Nayara Vianna
            </h3>
            <p style={{ margin: '0 0 5px', color: '#64748b', fontSize: 13 }}>
              Analista Financeiro
            </p>
            <p style={{ margin: '0 0 12px', color: '#64748b', fontSize: 13 }}>
              FTP — Coordenação de Processos
            </p>
            <a href={emailNayara} style={actionStyle}>
              <Mail size={16} />
              nayara@cpfl.com.br
            </a>
          </div>

          <div style={contatoCardStyle}>
            <h3 style={{ margin: '0 0 10px', color: '#1e293b', fontSize: 15 }}>
              Ronaldo Douglas Zanes
            </h3>
            <p style={{ margin: '0 0 12px', color: '#64748b', fontSize: 13 }}>
              Contato CPFL
            </p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              <a href={emailRonaldo} style={actionStyle}>
                <Mail size={16} />
                ronaldo.zanes@cpfl.com.br
              </a>
              <a
                href={whatsappRonaldo}
                target="_blank"
                rel="noopener noreferrer"
                style={actionStyle}
              >
                <MessageCircle size={16} />
                WhatsApp (19) 99328-4705
                <ExternalLink size={14} />
              </a>
            </div>
          </div>
        </div>
      </section>

      <section style={{
        ...cardStyle,
        padding: 16,
        borderColor: '#fde68a',
        background: '#fffbeb',
        boxShadow: 'none',
      }}>
        <p style={{ margin: 0, color: '#78350f', fontSize: 13, lineHeight: 1.6 }}>
          O botão de e-mail abre um rascunho no aplicativo de correio configurado
          neste computador. Confira os destinatários e substitua os campos entre
          colchetes antes de enviar.
        </p>
      </section>
    </div>
  );
}

export default function SuporteHome({ sistema }) {
  const nome = String(sistema || 'SUPORTE').toUpperCase();

  return (
    <main style={{
      maxWidth: 1100,
      margin: '0 auto',
      padding: '28px 32px 44px',
      color: '#0f172a',
    }}>
      <header style={{
        display: 'flex',
        alignItems: 'center',
        gap: 14,
        marginBottom: 22,
      }}>
        <div style={{
          display: 'grid',
          placeItems: 'center',
          width: 44,
          height: 44,
          borderRadius: 12,
          color: '#2563eb',
          background: '#eff6ff',
        }}>
          <MessageCircle size={21} />
        </div>
        <div>
          <span style={{
            color: '#64748b',
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: '.08em',
          }}>
            SUPORTE
          </span>
          <h1 style={{ margin: '3px 0 0', color: '#172b3d', fontSize: 24 }}>
            {nome}
          </h1>
          <p style={{ margin: '5px 0 0', color: '#64748b', fontSize: 14 }}>
            {descricoes[nome] || 'Área inicial de suporte.'}
          </p>
        </div>
      </header>

      {nome === 'ASAAS' ? (
        <SuporteAsaas />
      ) : nome === 'PIX TOOLS' ? (
        <SuportePixTools />
      ) : nome === 'CPFL' ? (
        <SuporteCpfl />
      ) : (
        <section style={cardStyle}>
          <h2 style={{ margin: '0 0 8px', color: '#1e293b', fontSize: 17 }}>
            Central de suporte — {nome}
          </h2>
          <p style={{ margin: 0, color: '#64748b', fontSize: 14, lineHeight: 1.5 }}>
            Esta página inicial está pronta para receber ferramentas e procedimentos específicos.
          </p>
        </section>
      )}
    </main>
  );
}
